import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const timerNodeSpec: NodeSpec<NodeCfg<'timer'>> = {
    requiredSockets: [ 'start', 'initialValue' ],
    cfg: () => ({ controlValues: { dir: 'down', limit: 0 }, id: getUID(), kind: 'timer', disabled: false, width: 200 }),
    controls: nodeCfg => ({
        dir: defineControlOpts({
            cfg: {
                items: [
                    { label: 'Count Up', value: 'up' },
                    { label: 'Count Down', value: 'down' },
                ],
                kind: 'selection',
                label: 'Mode',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.dir,
        }),
        limit: defineControlOpts({
            cfg: { kind: 'number', label: 'Limit', min: 0 },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.limit,
        }),
    }),
    inputs: nodeCfg => ({
        start: { socket: 'event', label: 'Start' },
        stop: { socket: 'event', label: 'Stop' },
        reset: { socket: 'event', label: 'Reset' },
        initialValue: {
            controlOpts: defineControlOpts({
                cfg: { kind: 'number' },
                on: { 'update:value': defaultControlUpdateValueHandler },
                value: nodeCfg.socketDefaults?.inputs?.initialValue ?? null,
            }),
            socket: 'number',
            label: 'Initial Value',
        },
    }),
    kindLabel: 'Timer',
    nodeCategory: 'timeAndDate',
    outputs: () => ({
        done: { socket: 'event', label: 'Done' },
        tick: { socket: 'event', label: 'Tick' },
        value: { socket: 'number', label: 'Value' },
    }),
    validator: node => node.controlValues.limit >= 0 ? true : { limit: 'Limit must be at least 0' },
};
